import { useAppSelector } from '../redux/store'

export const useEditorBlocks = () => {
  const blocks = useAppSelector((s) => s.editor.blocks)

  return blocks
}
